
export const TunnelType = {
    RECTANGLE: {
        label: "矩形管",
        value: 1,
        image: require('@/commons/icons/section/CF-RT/CF-RT_3@3x.png'),
        thumbnail: require('@/commons/icons/section/CF-RT/CF-RT@3x.png'),
    },
    TUBE: {
        label: "圆管",
        value: 2,
        image: require('@/commons/icons/section/HR-CT/HR-CT_3@3x.png'),
        thumbnail: require('@/commons/icons/section/HR-CT/HR-CT@3x.png'),
    }
}

export const TunnelEnum = {
    RECTANGLE: 1,
    TUBE: 2
}

export function getLabelByValue(value: number) {
    let key = Object.keys(TunnelType).find(item => TunnelType[item].value == value);
    return TunnelType[key].label || '';
}
export function getTunnelImgByValue(value: number) {
    let key = Object.keys(TunnelType).find(item => TunnelType[item].value == value);
    return TunnelType[key].thumbnail || '';
}

